Namespace 'Monitoring.Reports.DailyInsights'

class Monitoring.Reports.DailyInsights.PostsView extends Backbone.View

  tagName: 'section'
  template: JST['backbone/templates/monitoring/reports/daily_insights/section']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    if @options.graySection
      @$el.addClass("gray-section")
    @$el.html(@template(@options))
    @$el.addClass(@options.section + '-posts-section')
    posts = @options.channel.contents
    for post in posts
      post.channel_id = @options.channel.network_id
      if @options.section == "facebook"
        section = new Monitoring.Reports.DailyInsights.FacebookPostView($.extend({}, @options, {post: post}))
      else if @options.section == "twitter"
        section = new Monitoring.Reports.DailyInsights.TwitterPostView($.extend({}, @options, {post: post}))
      else
        if @fromFacebookApi(post)
          post.channel_id = @options.channel.fb_network_id
          section = new Monitoring.Reports.DailyInsights.FacebookPostView($.extend({}, @options, {post: post}))
        else
          section = new Monitoring.Reports.DailyInsights.InstagramPostView($.extend({}, @options, {post: post}))
      section.render()
      @$('.data').append(section.el)

  fromFacebookApi:(post) =>
    post.updated_data != undefined